import { CommonModule, DecimalPipe } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SelectModule } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';

import { UiModule } from '@ui';

import { CmgSharedModule } from '../shared';
import { ErrorHandlerService } from './services';

import * as COMPONENTS from './components';
import * as PIPES from './pipes';

@NgModule({
  imports: [
    AutoCompleteModule,
    ButtonModule,
    CardModule,
    CmgSharedModule,
    CommonModule,
    ConfirmDialogModule,
    DrawerModule,
    SelectModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    ProgressBarModule,
    RadioButtonModule,
    ReactiveFormsModule,
    RouterModule,
    TooltipModule,
    UiModule,
    COMPONENTS.ConfirmationModalComponent,
    COMPONENTS.FailedToLoadModalComponent,
    COMPONENTS.FileUploader34Component,
    COMPONENTS.LoginComponent,
    COMPONENTS.LoginFailedComponent,
    COMPONENTS.LoginFooterComponent,
    COMPONENTS.LogoutComponent,
    COMPONENTS.LogoutWarningComponent,
    COMPONENTS.NavbarComponent,
    COMPONENTS.PageNotAllowedComponent,
    COMPONENTS.PageNotFoundComponent,
    COMPONENTS.SecurityProfilesComponent,
    COMPONENTS.SidebarMenuComponent,
    COMPONENTS.SwitchProfilesComponent,
    COMPONENTS.Upload34Component,
    COMPONENTS.VersionNumberComponent,
    PIPES.SafePipe,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService,
    },
    DecimalPipe,
  ],
  exports: [
    COMPONENTS.ConfirmationModalComponent,
    COMPONENTS.NavbarComponent,
    COMPONENTS.PageNotAllowedComponent,
    COMPONENTS.PageNotFoundComponent,
    COMPONENTS.SidebarMenuComponent,
    COMPONENTS.VersionNumberComponent,
  ],
})
export class CoreModule {}
